export default "__VITE_ASSET__BD1rgJyT__"